import { render, staticRenderFns } from "./BadgeStylePreview.vue?vue&type=template&id=1b77a504&scoped=true"
import script from "./BadgeStylePreview.vue?vue&type=script&lang=js"
export * from "./BadgeStylePreview.vue?vue&type=script&lang=js"
import style0 from "./BadgeStylePreview.vue?vue&type=style&index=0&id=1b77a504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77a504",
  null
  
)

export default component.exports